import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../formInputsV2/styles/tokens';

export const EuropeCristalliInfoModalStyles = styled.div`
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: ${v2FontFamily};

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    overflow-y: hidden;
  }
`;

export const ModalBody = styled.div`
  width: 80%;
  height: 80%;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 64px rgba(16, 24, 40, 0.24);

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    width: 90%;
    height: 90%;
    border-radius: 16px;
    overflow-y: hidden;
  }
`;

export const ModalHeader = styled.div`
  position: relative;
  padding: 22px 64px 22px 24px;
  background: #fff;
  border-bottom: 1px solid ${v2Colors.disabledSurface};
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    padding: 16px 56px 16px 16px;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid ${v2Colors.disabledBorder};
  border-radius: 50%;
  background: ${v2Colors.surface};
  color: ${v2Colors.textMuted};
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    border-color: ${v2Colors.borderStrong};
    background: ${v2Colors.disabledSurface};
    color: ${v2Colors.text};
  }

  &:focus-visible {
    outline: 0;
    border-color: ${v2Colors.primary};
    box-shadow: 0 0 0 3px ${v2Colors.primarySoftHover};
  }

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    top: 12px;
    right: 12px;
    width: 40px;
    height: 40px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  margin: 0;
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    margin-top: 8px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  p {
    margin: 0;
    color: ${v2Colors.textMuted};
    font-family: ${v2FontFamily};
    font-size: 13.5px;
    font-weight: 500;
    line-height: 1.45;
  }

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    p {
      font-size: 13px;
    }
  }
`;

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 5px;

  h3 {
    margin-bottom: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 19px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }

  img {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
  }

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    h3 {
      font-size: 17px;
    }

    img {
      width: 22px;
      height: 22px;
    }
  }
`;

export const ModalContent = styled.div`
  padding: 20px 24px;
  overflow-y: auto;
  height: 76%;
  background: ${v2Colors.surface};

  h3 {
    margin-bottom: 8px;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 17px;
    font-weight: 700;
    line-height: 1.3;
  }

  p {
    color: ${v2Colors.textMuted};
    font-family: ${v2FontFamily};
    font-size: 13.5px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 0;

    b {
      color: ${v2Colors.text};
      font-weight: 600;
    }
  }

  .card-extra-information {
    overflow-y: hidden;
    height: auto;

    h3 {
      margin-top: 16px;
    }
  }

  @media only screen and (max-width: ${v2Breakpoints.tablet}) {
    padding: 16px;
    height: 70%;

    h3 {
      font-size: 15.5px;
      margin-bottom: 8px;
    }

    p {
      font-size: 13px;
    }

    .card-extra-information {
      padding-bottom: 20px;
    }
  }
`;
